import SVG from "react-inlinesvg";
import { Popover } from "buba-components-ts";
import cx from "classnames";

import { PopoverRenderProps } from "../Popover/Popover";

import styles from "./Dropdown.scss";

export type DropdownOptions = Array<{
  text: () => React.ReactNode;
  onClick: (closePopover: () => void) => void;
  title: string;
}>;

interface DropdownProps {
  options: DropdownOptions;
  activeIndex?: number;
  icon?: string;
  popperWidth?: number;
  onLeft?: boolean;
}

interface ContentParams {
  closePopover: () => void;
}

const Dropdown = ({
  options,
  activeIndex = -1,
  icon = "",
  popperWidth = 200,
  onLeft = false
}: DropdownProps) => {
  const combinedStyles = [styles];

  return (
    <div className={cx(...combinedStyles.map(c => c.dropdownWrapper))}>
      <Popover
        input={({ triggerRef, onFocus }: PopoverRenderProps) => (
          <button
            className={cx(
              ...combinedStyles.map(c => c.triggerButton),
              ...combinedStyles.map(c => ({ [c.activeButton]: activeIndex >= 0 }))
            )}
            type="button"
            ref={triggerRef}
            data-testid="dropdownTrigger"
            data-closeonshifttab
            aria-label="dropdown"
            onFocus={onFocus}
          >
            <SVG className={cx(...combinedStyles.map(c => c.icon))} src={icon} />
          </button>
        )}
        content={({ closePopover }: ContentParams) => (
          <div className={styles.buttonsWrapper} data-testid="dropdownButtonsWrapper">
            {options.map(({ text, onClick, title }, optionIndex) => {
              const isActive = optionIndex === activeIndex;
              const content = text();

              return (
                <button
                  className={isActive ? styles.isActive : undefined}
                  type="button"
                  onClick={() => onClick(closePopover)}
                  key={optionIndex}
                  title={title}
                  data-isactive={isActive}
                  data-closeontab={options.length === optionIndex + 1}
                >
                  {content}
                </button>
              );
            })}
          </div>
        )}
        popperWidth={popperWidth}
        onLeft={onLeft}
      />
    </div>
  );
};

export default Dropdown;
